export default class PageHelper{ 
public static openingDViewerBox = "";
public static descriptionInDialogue = "";
public static overlayWrapperClass = "";
    //D.Viewer dialog
public static async dViewerOpeningDialog(title:string, button:string, description:string) {

    var templateBox = this.openingDViewerBox
        .replace('$title', title)
        .replace('$button', button || 'Cancel')

    if (description) {
        var div = document.createElement('div');
        div.innerHTML = PageHelper.openingDViewerBox.trim();
      
        // Change this to div.childNodes to support multiple top-level nodes.
        
        let $templateBox = div;
        let $descEl = (this.descriptionInDialogue.replace('$description', description));
        $templateBox.querySelector('h1')?.after($descEl);
        templateBox = $templateBox.outerHTML;
    }

    PageHelper.addOverlay(null, {
        close: false,
        contentBox: false,
        content: templateBox,
        contentBoxClass: this.overlayWrapperClass
    });

    var declineButton = document.querySelector(this.overlayWrapperClass + ' .govuk-button--warning');

    declineButton?.addEventListener('click', function (e) {
        if (e.type == 'click') {
            PageHelper.removeOverlay();
            return;
        }
    });
    declineButton?.addEventListener("keydown",function(e:any){
        if(e.key === "Enter"){
            PageHelper.removeOverlay();
            return;
        }
    })

}
public static addOverlay(param:any , object?:any){

}
public static addPanelBox(context:any,param:any , object?:any){

}
public static removeOverlay(){

}
}